import { AppThemeType } from 'store/types';
import styled from 'styled-components';

export const SkeletonWrapper = styled.div<{ $appTheme: AppThemeType }>`
  ${({ theme, $appTheme }) => `
    position: relative;
    background-color: ${$appTheme === 'light' ? '#eee' : theme.background.section};
    overflow: hidden;
  `}
`;

export const SkeletonShimmer = styled.div<{ $appTheme: AppThemeType }>`
  ${({ theme, $appTheme }) => `
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(to left, transparent, ${$appTheme === 'light' ? '#F6F6F6' : '#7d7d7d'}, transparent);
    animation: skeletonShimmer 1.3s ease-in-out infinite;

    @keyframes skeletonShimmer {
        0% {
            transform: translateX(-100%);
        }

        100% {
            transform: translateX(100%);
        }
    }
  `}
`;
